import { PartState } from '../types';
import { facingRightState } from './facing-right';

/**
 * Flying right state — Bizy facing right and leaning 45° into flight.
 * Left arm extended upward like Superman in the direction of flight.
 */
export const flyingRightState: PartState = {
	...facingRightState,
	arms: [
		// Left arm angled out and down so it's visible past the body
		{ d: 'M167 145L155 170C154 173 152 176 150 178L138 190', side: 'left' },
		// Right arm extended upward — Superman pose, well past body edge
		{ d: 'M185 130L200 95C202 89 205 83 208 78L220 62', side: 'right' },
	],
	bodyRotation: 45,
};
